import axios from "axios";

export default function updateAutoReply({ context, message, isActive }) {
  const body = {};
  if (message !== undefined) body.message = message;
  if (isActive !== undefined) body.is_active = isActive;
  return new Promise((resolve, reject) =>
    axios
      .put(`/support/api/v1/admin/auto-replies/${context}`, body)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
